<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="locations" search pagination max-items="15">
      <template slot="header">
        <h3>
          Területek
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addLocation()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Helység neve
        </vs-th>
        <vs-th>
          Házhozszállítás összege
        </vs-th>
        <vs-th>
          Minimum rendelés
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.LocationName }}
          </vs-td>
          <vs-td>
            {{ tr.DeliveryPrice }}
          </vs-td>
          <vs-td>
            {{ tr.MinimumOrder }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editLocation(tr.Id)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delLocation(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addPaymentModal" title="Új fizetési mód hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_location v-bind:selected="selected"></new_location>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editPaymentModal" title="Fizetési mód módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_location v-bind:selected="selected"></edit_location>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_location from "@/components/modals/new_location";
import edit_location from "@/components/modals/edit_location";

export default {
  name: "locations",
  data() {
    return {
      locations: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        LocationName: '',
        DeliveryPrice: 0,
        MinimumOrder: 0
      }
    }
  },
  components: {
    new_location, edit_location
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getLocations();
    },
    getLocations() {
      let self = this;
      axiosInstance
          .get('admin/deliveryLocationController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.locations = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addLocation() {
      this.selected.LocationName = '';
      this.selected.DeliveryPrice = 0;
      this.selected.MinimumOrder = 0;
      this.addModal = true;
    },
    editLocation(id) {
      this.selected = {...this.locations.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delLocation(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a helységet?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/deliveryLocationController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getLocations();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getLocations();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>